module.exports = __webpack_public_path__ + "static/media/014-Regulars Bar.c1bb995b.png";